import { render } from "./waterDetail.vue?vue&type=template&id=08a4478c&scoped=true"
import script from "./waterDetail.vue?vue&type=script&lang=js"
export * from "./waterDetail.vue?vue&type=script&lang=js"

import "./waterDetail.vue?vue&type=style&index=0&id=08a4478c&lang=scss&scoped=true"

import exportComponent from "D:\\work\\Organizationpersonnel\\organization_personnel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a4478c"]])

export default __exports__